<ng-container *ngIf="!configMode" class="non-config-mode-container">
    <div (click)="onClick()" class="non-config-mode-container">
        <p *ngIf="event && !isEventPredefined" class="event-name" [title]="event?.name"><span>{{event?.name}}</span></p>
        <p *ngIf="eventNotAvailable" class="event-name the-event-is-no-longer-available">
            <span translate>THE_EVENT_IS_NO_LONGER_AVAILABLE</span>
        </p>
        <p class="information">
            <span translate>TO_EVENT_START_DATE</span>
        </p>
        <div *ngIf="event && isCountdownStarted" class="clock-container">
            <img *ngFor="let path of clockWidgetAssetsConfig.daysPaths" class="clock-digit" [src]="path">
            <img [src]="clockWidgetAssetsConfig.colonPath" class="clock-digit">
            <img [src]="clockWidgetAssetsConfig.hour1" class="clock-digit">
            <img [src]="clockWidgetAssetsConfig.hour2" class="clock-digit">
            <img [src]="clockWidgetAssetsConfig.colonPath" class="clock-digit">
            <img [src]="clockWidgetAssetsConfig.minute1" class="clock-digit">
            <img [src]="clockWidgetAssetsConfig.minute2" class="clock-digit">
            <img [src]="clockWidgetAssetsConfig.colonPath" class="clock-digit">
            <img [src]="clockWidgetAssetsConfig.second1" class="clock-digit">
            <img [src]="clockWidgetAssetsConfig.second2" class="clock-digit">
        </div>
        <h2 *ngIf="eventHasStarted">
            <span translate>THE_EVENT_HAS_STARTED</span>
        </h2>
        <azavista-button *ngIf="!isEventPredefined" class="navigate-event">
            <span translate>GO_TO_EVENT</span>
        </azavista-button>
    </div>
</ng-container>

<div *ngIf="configMode" class="config-mode-container">
    <div class="settings-container">
        <div class="setting-item">
            <div class="aza-pa-flex-row">
                <div *ngIf="event" class="aza-pa-flex-row">
                    <span translate>EVENT</span>:
                    <span>{{event.name}}</span>
                </div>
                <azavista-button *ngIf="!isEventPredefined" (click)="onSelectEvent()">
                    <span translate>SELECT_EVENT</span>
                </azavista-button>
            </div>
        </div>
    </div>
</div>
